import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import PipelineDefinitionsTab from '../../components/admin/PipelineDefinitionsTab';

// `?kind=deal|contact|event_contact` picks the tab to open (the Lead Pipeline settings link here);
// `&history=1` opens that pipeline's version history straight away.
export default function AdminPipelinesPage() {
    const [searchParams] = useSearchParams();
    const kind = searchParams.get('kind') || undefined;
    const history = searchParams.get('history') === '1';
    return (
        <AdminLayout title="Pipelines" description="Stages, version history and templates for the Deal Pipeline, the Lead Pipeline and Event Outreach">
            <PipelineDefinitionsTab key={`${kind}-${history}`} initialKind={kind} initialHistory={history} />
        </AdminLayout>
    );
}
